const snackbarModule = {
  state: {
    show: false,
    contentColor: 'default',
    header: '',
    message: '',
    status: null,
    timer: 3,
    bgColor: '',
    fontColor: '',
    action: {
      name: null,
      handler: null,
    },
  },
  mutations: {
    SET_SNACKBAR: (state, payload) => {
      const {
        header,
        message,
        show,
        status,
        timer,
        bgColor,
        fontColor,
        action,
      } = payload;
      state.header = header;
      state.message = message;
      state.show = show;
      state.status = status;
      state.timer = timer;
      state.bgColor = bgColor;
      state.fontColor = fontColor;
      state.action = action;
    },
    CHANGE_SNACKBAR_VALUES: (state, payload) => {
      const {
        changes,
      } = payload;
      changes.forEach((change) => {
        const {
          field,
          value,
        } = change;
        if (state[field] !== undefined) {
          state[field] = value;
        }
      });
    },
  },
  actions: {
    changeSnackbarValues({ commit }, payload) {
      commit('CHANGE_SNACKBAR_VALUES', {
        changes: payload,
      });
    },
    showSuccessToast({ commit }, payload) {
      const {
        header,
        message,
      } = payload;
      commit('SET_SNACKBAR', {
        show: true,
        header,
        message,
        bgColor: '#2759E4',
        fontColor: '#FFF',
        timer: 3,
      });
    },
    showAlertToast({ commit }, payload) {
      const {
        header,
        message,
      } = payload;
      commit('SET_SNACKBAR', {
        show: true,
        header,
        message,
        status: 'error',
      });
    },
    showSuccessToastBanner({ commit }, payload) {
      const {
        header,
        message,
      } = payload;
      commit('SET_SNACKBAR', {
        show: true,
        header,
        message,
        status: 'success',
      });
    },
    closeSnackbar({ commit }) {
      commit('SET_SNACKBAR', {
        show: false,
        message: '',
        color: '',
        status: null,
      });
    },
  },
};

export default snackbarModule;
